import api from '../api';

import { ParamsBodyGetVirtualFencesHistory, ParamsDataGetVirtualFencesHistory } from 'utils/typeServices';

type ParamsResponse = {
    Data: Array<ParamsDataGetVirtualFencesHistory>;
}

export const PostGetVirtualFencesHistory = async ({ body }: { body: ParamsBodyGetVirtualFencesHistory }) => {
    const bodyJson = JSON.stringify(body);
    const token = localStorage.getItem('token');

    try {
        const { data } = await api.post<ParamsResponse>('/v1/Sistemas/GetVirtualFencesHistory', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
